import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue';
import { createArticle } from '@/services/news/article.service';
import type { Article, CreateArticleRequest } from '@/services/news/article.model';
import ArticleForm from '@/components/Cms/ArticleForm/ArticleForm.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddArticle',
  setup(__props) {

const loading = ref(false);
const success = ref(false);
const errorMessage = ref('');

async function handleCreateArticle(payload: CreateArticleRequest) {
  loading.value = true;
  success.value = false;
  errorMessage.value = '';

  try {
    await createArticle(payload);
    success.value = true;
  } catch (err: any) {
    console.error(err);
    errorMessage.value = err?.message || 'Failed to create article.';
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "fill-height d-flex align-center justify-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "pa-6 w-100",
        "max-width": "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5 text-center mb-4" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Add New Article", -1)
            ]))]),
            _: 1
          }),
          _createVNode(ArticleForm, {
            onSubmit: handleCreateArticle,
            loading: loading.value
          }, null, 8, ["loading"]),
          (errorMessage.value)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                type: "error",
                variant: "tonal",
                class: "mt-4 text-center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(errorMessage.value), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (success.value)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 1,
                type: "success",
                variant: "tonal",
                class: "mt-4 text-center"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" Article created successfully. ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})